import React from "react";

const ExperienceCard = ({ logo, company, title, time }) => {
  return (
    <div className="flex items-center justify-between w-full bg-[#c0c0c0] border-[0.12rem] border-t-[#f5f5f5] border-l-[#f5f5f5] border-b-black border-r-black px-4 py-2 shadow-sm">
      {/* Logo Section */}
      <div className="flex items-center">
        <img
          src={logo}
          alt={`${company} Logo`}
          className="h-12 w-12 mr-4 border-[0.12rem] border-t-[#f5f5f5] border-l-[#f5f5f5] border-b-black border-r-black"
        />
      </div>

      {/* Text Section */}
      <div
        className="flex-1 border-[0.12rem] border-t-[#7f787e] border-l-[#7f787e] border-b-white border-r-white px-3 py-2 relative experience-card-checker"
      >
        {/* Company Name and Title */}
        <div className="flex justify-between items-center">
          <div>
            <h3 className="text-[1.22rem] font-bold">{company}</h3>
            <p className="text-[0.95rem]">{title}</p>
          </div>
          {/* Time Period */}
          <p className="text-[0.95rem] font-bold">{time}</p>
        </div>
      </div>
    </div>
  );
};

export default ExperienceCard;
